import { Operation } from '../../../__generated__/globalTypes'

import getNotificationCountString from '../GetNotificationCount.graphql'

export type GetNotificationCountData = {
  notificationCount: number
}

export type GetNotificationCount = Operation<GetNotificationCountData>

export const GetNotificationCount = (): GetNotificationCount => ({
  query: getNotificationCountString,
  variables: undefined,
})
